import mitt from 'mitt';

type Events = {
  'request-updated': void;
  'notes-updated': void;
  'time-tracking-updated': void;
  'network-status-changed': { isOnline: boolean };
};

const emitter = mitt<Events>();

export const useEventBus = () => {
  return {
    emit: emitter.emit,
    on: emitter.on,
  }
}
